import AuthState from "#state/AuthState";
import { User } from 'oidc-client';
import React from 'react';

export interface IAuthContext extends AuthState {
  signInSilent: () => Promise<User>;
  signInRedirect: (path?: string) => void;
  signOut: () => void;
  signOutRedirectCallback: () => void;
  hasPermission: (permissionName: string) => boolean;
  accessToken?: string;
  isAuthenticated: boolean;
  isLoading: boolean;
  error?: Error;
  user?: User;
  isSignIn?: boolean;
}

export const AuthContext = React.createContext<IAuthContext | null>(null);

export const useAuth = (): IAuthContext => {
  const ctx = React.useContext(AuthContext);
  if (ctx) return ctx;

  // fallback to a safe default so callers can destructure without throwing
  return {
    signInSilent: () => Promise.reject(new Error('Auth provider not initialized')),
    signInRedirect: () => {},
    signOut: () => {},
    signOutRedirectCallback: () => {},
    hasPermission: () => false,
    accessToken: undefined,
    isAuthenticated: false,
    isLoading: false,
    error: undefined,
    user: undefined,
    isSignIn: false
  } as IAuthContext;
};